import React, { useEffect, useMemo, useState } from 'react'
import Box from '../Box'
import Icon from '../Icon'
import Input from '../Input'

import colors from '../../constants/colors'
import { CheckboxProps } from './Checkbox.types'
import Flex from '../Flex'

const Checkbox: React.FC<CheckboxProps> = ({
  onChange,
  _checkedException,
  id = null,
  indeterminate = false,
  checked = false,
  disabled = false,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked)
  const isRenderIcon = useMemo(() => isChecked || indeterminate, [isChecked, indeterminate])

  const getIcon = () => {
    if (isChecked) return 'Checkmark-outline'
    if (indeterminate) return 'Minus-outline'
  }

  const getBgColor = () => {
    if (isChecked || indeterminate) return 'blue50'
    if (disabled) return 'black10'
    return 'white'
  }

  const onChecked = () => {
    !_checkedException && setIsChecked((prevState) => !prevState)
    onChange(!isChecked)
  }

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  return (
    <Flex
      as='label'
      htmlFor={id}
      height='20px'
      width='20px'
      border={`1px solid ${colors.black50}`}
      borderColor={isChecked || indeterminate ? 'blue50' : 'black50'}
      backgroundColor={getBgColor()}
      borderRadius='4px'
      opacity={disabled && (isChecked || indeterminate) ? '0.25' : '1'}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      onChange={onChecked}
      justifyContent='center'
      alignItems='center'
      // will fixed by @GannaHUP
      style={{ boxSizing: 'border-box' }}
    >
      {isRenderIcon && (
        <Box flex={1}>
          <Icon name={getIcon()} size={20} color='white' />
        </Box>
      )}
      <Input id={id} type='checkbox' hidden checked={isChecked || checked} {...props} />
    </Flex>
  )
}

export default Checkbox
